import { getMethodWithParamWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const SEARCH_BRANCH_PROVIDER_LIST = 'SEARCH_BRANCH_PROVIDER_LIST';
export const SEARCH_BRANCH_PROVIDER_LIST_SUCCESS =
  'SEARCH_BRANCH_PROVIDER_LIST_SUCCESS';
export const SEARCH_BRANCH_PROVIDER_LIST_FAILURE =
  'SEARCH_BRANCH_PROVIDER_LIST_FAILURE';

// Action Creators
export const fetchGetSearchBranchProvider = () => ({
  type: SEARCH_BRANCH_PROVIDER_LIST,
});

export const fetchGetSearchBranchProviderSuccess = (data) => ({
  type: SEARCH_BRANCH_PROVIDER_LIST_SUCCESS,
  payload: data,
});

export const fetchGetSearchBranchProviderFailure = (error) => ({
  type: SEARCH_BRANCH_PROVIDER_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getSearchBranchProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetSearchBranchProvider(data, external));
    try {
      const response = await getMethodWithParamWithToken(
        url.getSearchBranchProviderList,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetSearchBranchProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetSearchBranchProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetSearchBranchProviderFailure(error.message));
    }
  };
};
